import {_BaseObjectField } from "../../common/basic_fields.js";
import { DatePoint } from '../../js/datelib.js';
import mainStyles from '../../../css/site.scss';
import styles from './styles.scss';

function injectionRemoval(s) {
    return s ? tools.escapeTags(tools.removeExtraSpace(s)) : "";
}

class SummaryInput extends HTMLElement {
    /*
     * Attrributes:
     * type
     * css-salt
     * date-from
     * date-to
     * 
     * Structure of 'this._value': {
     *     type: repayment - "Досрочное погашение", withdrawal - "Частичное снятие", replenishment - "Пополнение вклада"
     *     name - user's commentary
     *     payment - number
     *     if type = 'repayment':
     *         purpose
     *     repeat: 'no', 'month', 'quarter' or 'year'
     *     day - calculated value, couldn't be set directly
     *     month - calculated value, couldn't be set directly
     *     quarter - calculated value, couldn't be set directly
     *     dateFrom - calculated value, couldn't be set directly
     *     dateTo - calculated value, couldn't be set directly
     *     mYFrom
     *     mYTo
     *     yearFrom
     *     yearTo
     *     date
     *     onlyWorkdays
     *     dMYDropdownValue
     *     dayDropdownValue
     *     dMDropdownValue
     *     dQDropdownValue
     *     wholePeriod
     *     defaultInputs - are important values equal to the default values
     * }
     */
    constructor() {
        super();

        //1. Constants and the default value

        //Catalogue of supported types
        const allowedTypes = ["repayment", "withdrawal", "replenishment"];

        //Get attributes
        const type = this.getAttribute('type');
        const cssSalt = this.getAttribute('css-salt');

        //Set unique id (only for checkbox, for now)
        const id = `${type}_${Math.floor(Math.random() * 10000)}${Date.now()}`;

        //Fill the dropdowns
        const basicRepeatOptions = [
            { text: 'единовременно', value: 'no' },
            { text: 'повторять раз в месяц', value: 'month' },
            { text: 'повторять раз в год', value: 'year' }
        ];

        const extendedRepeatOptions = [
            { text: 'единовременно', value: 'no' },
            { text: 'повторять ежемесячно', value: 'month' },
        ];

        const dropdowns = {
            purpose: [{ text: 'уменьшение суммы платежа', value: 'sum' }, { text: 'уменьшение срока кредита', value: 'term' }],
            repeat: type == "repayment" ? basicRepeatOptions : extendedRepeatOptions,
        };

        //Default value
        this._defaultValue = {
            type,
            name: "",
            payment: "",
            repeat: 'no',
            day: 0,
            month: 0,
            date: '',
            dateFrom: '',
            dateTo: '',
            mYFrom: '',
            mYTo: '',
            yearFrom: '',
            yearTo: '',
            dayDropdownValue: '',
            dMDropdownValue: '',
            dQDropdownValue: '',
            wholePeriod: true,
            onlyWorkdays: false,
            defaultInputs: true
        };
        if (type == "repayment") {
            this._defaultValue.purpose = null;
        }

        //2. Inner functions

        const setDays = (lastDay = 31) => {
            dropdowns.days = [];
            for (let i = 1; i <= lastDay; i++) {
                dropdowns.days.push({ text: i < 10 ? '0' + i : i, value: i });
            }
        };

        const getDropdownFiller = (name, selectedValue) => {
            let filler = '';
            dropdowns[name].forEach(o => {
                filler += '<option value="' + o.value + '"' + (selectedValue == o.value ? ' selected' : '') + '>' + o.text + '</option>';
            });
            return filler;
        };

        const getDropdownText = (name, value) => {
            const el = dropdowns[name].find(o => o.value == value);
            return el ? el.text : null;
        };

        //Update outer information
        const updateText = () => {
            //Check type
            if (!allowedTypes.find(t => t == type))
                return;

            //name
            this.$elements.$nameText.html(this._value.name || ``);
            if (this._value.name) {
                this.$elements.$nameText.removeClass('hidden-control');
            } else
                this.$elements.$nameText.addClass('hidden-control');

            //money
            this.$elements.$moneyText.html(
                (this._value.payment || 0).toLocaleString('ru-RU', { minimumFractionDigits: 2 }) + ` \u20BD`
            );

            //fresh - show only when the window wasn't changed
            this.$elements.$freshText.html(`укажите сумму` + (type == "repayment" ? ', тип' : '') +
                (this._value.repeat == "no" ? ' и дату ' + (type == "repayment" ? 'погашения' : '') + (type == "withdrawal" ? 'снятия' : '') + (type == "replenishment" ? 'пополнения' : '') :
                    this._value.wholePeriod ? ' и дату повторения' : ', дату и период повторения'));
            if (this._value.defaultInputs)
                this.$elements.$freshText.removeClass('hidden-control');
            else
                this.$elements.$freshText.addClass('hidden-control');

            if (type == "repayment") {
                //purpose
                this.$elements.$purposeText.html(getDropdownText('purpose', this._value.purpose));
                if (!this._value.defaultInputs && this._value.purpose)
                    this.$elements.$purposeText.removeClass('hidden-control');
                else
                    this.$elements.$purposeText.addClass('hidden-control');
            }

            //repeat
            let spanRepeat = `повторять `;
            switch (this._value.repeat) {
                case 'year': {
                    if (this._value.dMDropdownValue) {
                        spanRepeat += `${this.$elements.$dMDateDropdown[0].text} каждого года`;
                    }
                    break;
                }
                case 'month': {
                    switch (this._value.day) {
                        case -1: {
                            spanRepeat += `в конце месяца`;
                            break;
                        }
                        case 0: {
                            break;
                        }
                        default: {
                            spanRepeat += `${this.$elements.$dayDateDropdown[0].text} каждого месяца`;
                            break;
                        }
                    }
                    break;
                }
                case 'no': {
                    spanRepeat = this._value.date ? `единовременно ${this._value.date.toString()}` : ``;
                    break;
                }
                case 'day': {
                    spanRepeat += `каждый день`;
                    break;
                }
            }
            
            const monthsNames = [
                {to: 'январь', from: 'января'}, {to: 'февраль', from: 'февраля'},
                {to: 'март', from: 'марта'}, {to: 'апрель', from: 'апреля'},
                {to: 'май', from: 'мая'}, {to: 'июнь', from: 'июня'},
                {to: 'июль', from: 'июля'}, {to: 'август', from: 'августа'},
                {to: 'сентябрь', from: 'сентября'}, {to: 'октябрь', from: 'октября'},
                {to: 'ноябрь', from: 'ноября'}, {to: 'декабрь', from: 'декабря'}
            ];
            if (this._value.repeat != 'no') {
                if (this._value.wholePeriod)
                    spanRepeat += ` на&nbsp;протяжении всего срока ${type == "repayment" ? 'кредита' : 'вклада'}`;
                else {
                    let dateFromText = '';
                    let dateToText = '';
                    switch (this._value.repeat) {
                        case 'year': {
                            if (this._value.dateFrom)
                                dateFromText = `${this._value.dateFrom.date.getFullYear()} года`;
                            if (this._value.dateTo)
                                dateToText = `${this._value.dateTo.date.getFullYear()} год`;
                            break;
                        }
                        case 'month': {
                            if (this._value.dateFrom)
                                dateFromText = `${monthsNames[this._value.dateFrom.date.getMonth()].from} ${this._value.dateFrom.date.getFullYear()} года`;
                            if (this._value.dateTo)
                                dateToText = `${monthsNames[this._value.dateTo.date.getMonth()].to} ${this._value.dateTo.date.getFullYear()} года`;
                            break;
                        }
                    }
                    if (dateFromText && dateToText)
                        spanRepeat += ` с&nbsp;${dateFromText} по&nbsp;${dateToText}`;
                }
            }

            this.$elements.$repeatText.html(spanRepeat);
            if (!this._value.defaultInputs && (this._value.repeat == "no" && this._value.date || this._value.repeat != "no" && (this._value.day || this._value.wholePeriod || this._value.dateFrom && this._value.dateTo))) {
                this.$elements.$repeatDiv.removeClass('hidden-control');
            } else
                this.$elements.$repeatDiv.addClass('hidden-control');

            //onlyWorkdays
            if (!this._value.defaultInputs && this._value.onlyWorkdays)
                this.$elements.$onlyWorkdaysDiv.removeClass('hidden-control');
            else
                this.$elements.$onlyWorkdaysDiv.addClass('hidden-control');
        };

        //Change fields in the window after changing repeat type
        const afterChangeInRepeat = () => {
            this._value.repeat = this.$elements.$repetitionDropdown.val();

            switch (this._value.repeat) {
                case "year": {
                    this.$elements.$dMYDateDropdown.addClass('hidden-control');
                    this.$elements.$dayDateDropdown.addClass('hidden-control');
                    this.$elements.$dMDateDropdown.removeClass('hidden-control');
                    this.$elements.$period.removeClass('hidden-control');
                    this.$elements.$repetitionDropdown.attr('kind', "sharp-right");
                    this.$elements.$datesMY.addClass('hidden-control');
                    this.$elements.$datesYear.removeClass('hidden-control');
                    break;
                }
                case "month": {
                    this.$elements.$dMYDateDropdown.addClass('hidden-control');
                    this.$elements.$dayDateDropdown.removeClass('hidden-control');
                    this.$elements.$dMDateDropdown.addClass('hidden-control');
                    this.$elements.$period.removeClass('hidden-control');
                    this.$elements.$repetitionDropdown.attr('kind', "sharp-right");
                    this.$elements.$datesMY.removeClass('hidden-control');
                    this.$elements.$datesYear.addClass('hidden-control');
                    break;
                }
                case "no": {
                    this.$elements.$dMYDateDropdown.removeClass('hidden-control');
                    this.$elements.$dayDateDropdown.addClass('hidden-control');
                    this.$elements.$dMDateDropdown.addClass('hidden-control');
                    this.$elements.$period.addClass('hidden-control');
                    this.$elements.$repetitionDropdown.attr('kind', "sharp-right");
                    break;
                }
                case "day": {
                    // currently unused
                    break;
                }
                default: {
                    break;
                }
            }
        };

        const calculateOutputValues = () => {
            this._value.day = 0;
            this._value.month = 0;
            this._value.dateFrom = '';
            this._value.dateTo = '';
            switch (this._value.repeat) {
                case 'month': {
                    if (this._value.dayDropdownValue)
                        this._value.day = +this._value.dayDropdownValue;
                    if (this._value.mYFrom)
                        this._value.dateFrom = new DatePoint('01.' + this._value.mYFrom);
                    if (this._value.mYTo) {
                        this._value.dateTo = new DatePoint('01.' + this._value.mYTo);
                        this._value.dateTo.addMonths(1);
                        this._value.dateTo.inc(-1);
                    }
                    break;
                }
                case 'year': {
                    if (this._value.dMDropdownValue) {
                        const array = this._value.dMDropdownValue.split("\.");
                        this._value.day = +array[0];
                        this._value.month = +array[1];
                    }
                    if (this._value.yearFrom)
                        this._value.dateFrom = new DatePoint('01.01.' + this._value.yearFrom);
                    if (this._value.yearTo) {
                        this._value.dateTo = new DatePoint('01.01.' + (+this._value.yearTo+1));
                        this._value.dateTo.inc(-1);
                    }
                    break;
                }
            }
        }

        const recieveValues = () => {
            this._value.name = injectionRemoval(this.$elements.$nameInput.val());
            this._value.payment = this.$elements.$sumInput.val() ? tools.parseLocaleFloat(this.$elements.$sumInput.val()) : this._defaultValue.payment;

            if (type == "repayment") {
                this._value.purpose = this.$elements.$purposeDropdown.val();
            }

            this._value.onlyWorkdays = this.$elements.$onlyWorkdaysCheckbox.prop('checked');
            this._value.repeat = this.$elements.$repetitionDropdown.val();
            this._value.wholePeriod = this.$elements.$radioButtons.find("input[type=radio]:checked").val() == "whole";

            this._value.dayDropdownValue = this.$elements.$dayDateDropdown.val();
            this._value.dMDropdownValue = this.$elements.$dMDateDropdown.val();
            const dMYDateDropdown =this.$elements.$dMYDateDropdown.val();
            this._value.date = dMYDateDropdown ? new DatePoint(dMYDateDropdown, true) : '';
            this._value.mYFrom = this.$elements.$datesMYFrom.val();
            this._value.mYTo = this.$elements.$datesMYTo.val();
            this._value.yearFrom = this.$elements.$datesYearFrom.val();
            this._value.yearTo = this.$elements.$datesYearTo.val();

            calculateOutputValues();

            this._value.defaultInputs = this._defaultValue.defaultInputs;
            if (
                this._value.name != this._defaultValue.name ||
                this._value.payment != this._defaultValue.payment ||
                (this._value.repeat == 'no' &&
                    this._value.date != this._defaultValue.date) ||
                (this._value.repeat != 'no' &&
                    (this._value.dateFrom != this._defaultValue.dateFrom ||
                        this._value.dateTo != this._defaultValue.dateTo)) ||
                (this._value.repeat == 'month' &&
                    this._value.dayDropdownValue != this._defaultValue.dayDropdownValue) ||
                (this._value.repeat == 'year' &&
                    this._value.dQDropdownValue != this._defaultValue.dQDropdownValue)
            )
                this._value.defaultInputs = false;
        };

        this.setValues = (newValues) => {
            const values = newValues || this._defaultValue;

            this._value = tools.deepcopy(values);
            this._value.type = type; //type shouldn't be changed

            this.$elements.$nameInput.val(injectionRemoval(values.name));
            this.$elements.$sumInput.val(values.payment);

            if (type == "repayment") {
                this.$elements.$purposeDropdown.val(values.purpose);
            }

            this.$elements.$radioButtons.find("input[type=radio]").val([values.wholePeriod ? "whole" : "dates"]);

            this.$elements.$onlyWorkdaysCheckbox.prop('checked', values.onlyWorkdays);
            this.$elements.$repetitionDropdown.val(values.repeat);
            this.$elements.$dMYDateDropdown.val(values.date.toString());
            this.$elements.$dayDateDropdown.val(values.dayDropdownValue);
            this.$elements.$dMDateDropdown.val(values.dMDropdownValue);
            this.$elements.$datesMYFrom.val(values.mYFrom);
            this.$elements.$datesMYTo.val(values.mYTo);
            this.$elements.$datesYearFrom.val(values.yearFrom);
            this.$elements.$datesYearTo.val(values.yearTo);

            calculateOutputValues();

            afterChangeInRepeat();
            updateText();
        };

        const createHtml = () => {
            //Inside the window
            let title = "";
            switch (type) {
                case "repayment": {
                    title = "Досрочное погашение";
                    break;
                }
                case "withdrawal": {
                    title = "Частичное снятие";
                    break;
                }
                case "replenishment": {
                    title = "Пополнение вклада";
                    break;
                }
            }

            const pencilicon = `<i class="pencilicon"></i>`;
            const purposeDropdown = type == "repayment" ? `<div class="purpose"><dropdown-select placeholder="тип досрочного погашения" ie-fix><select slot="list">${getDropdownFiller("purpose")}</select></dropdown-select></div>` : ``;
            const dMYDateDropdown = `<date-dropdown type="day-month-year" kind="grip-left s-small" class="day-month-year" min-year="1995" max-year="+50" droplist-width="280px" ie-fix><div slot="header">${type == "repayment" ? "Дата досрочного погашения" : "Выберите дату"}</div></date-dropdown>`;
            const dayDateDropdown = `<date-dropdown type="day" default-value="-1" kind="grip-left" class="day hidden-control" ie-fix></date-dropdown>`;
            const dMDateDropdown = `<date-dropdown type="day-month" kind="grip-left" class="day-month hidden-control" ie-fix></date-dropdown>`;
            const mYFromDateDropdown = `<date-dropdown type="month-year" class="month-year date-from" kind="s-small" min-year="1995" max-year="+50" droplist-width="250px" ie-fix><div slot="header">Начало периода повторения</div></date-dropdown>`;
            const mYToDateDropdown = `<date-dropdown type="month-year" class="month-year date-to" kind="s-small" min-year="1995" max-year="+50" droplist-width="250px" ie-fix><div slot="header">Конец периода повторения</div></date-dropdown>`;
            const yearFromDateDropdown = `<date-dropdown type="year" class="year date-from" kind="s-small" min-year="1995" max-year="+50" ie-fix><div slot="header">Начало периода повторения</div></date-dropdown>`;
            const yearToDateDropdown = `<date-dropdown type="year" class="year date-to" kind="s-small" min-year="1995" max-year="+50" ie-fix><div slot="header">Конец периода повторения</div></date-dropdown>`;
            const radioButtons = `<div class="radio-container"><input type="radio" id="${id}_whole" name="${id}_period-radio" value="whole" checked autocomplete="off">` +
                `<label for="${id}_whole">Повторять на протяжении всего срока ${type == "repayment" ? 'кредита' : 'вклада'}</label></div>` +
                `<div class="radio-container"><input type="radio" id="${id}_dates" name="${id}_period-radio" value="dates" autocomplete="off">` +
                `<label for="${id}_dates">Указать период повторения</label></div>`;
            const onlyWorkdaysCheckbox = `<div class="only-workdays labeled-checkbox">` +
                `<div class="input-container-v1"><div class="checkboxrow">` +
                `<input id="${id}_only-workdays" type="checkbox" autocomplete="off" /><label class="input-label" for="${id}_only-workdays"></label>` +
                `<label class="checkboxrow-description" for="${id}_only-workdays">` +
                `${type == "repayment" ? 'переносить дату платежей, если платёж приходится на нерабочий день' : ''}` +
                `${type == "withdrawal" ? 'переносить снятие, если оно приходится на нерабочий день' : ''}` +
                `${type == "replenishment" ? 'переносить пополнение, если оно приходится на нерабочий день' : ''}` +
                `</label>` +
                `</div></div></div>`;

            const windowDiv = `<div class="window-div">` +
                `<div class="title input-icon input-icon-right"><input class="base-input" placeholder="${title}" type="text" maxlength="28" autocomplete="off" />` +
                `${pencilicon}</div>` +
                `<div class="field-div"><div class="input-icon input-icon-right sum-field larger"><input class="base-input" type="text" maxlength="18" autocomplete="off" /><i class="rubble"></i></div></div>` +
                `${purposeDropdown}` +
                `<div class="repetition"><div class="selectors"><dropdown-select kind="sharp-right" droplist-width="384px" ie-fix><select slot="list">${getDropdownFiller('repeat', 'no')}</select></dropdown-select>` +
                `<div class="input-icon date">` +
                `${dMYDateDropdown}` + `${dayDateDropdown}` + `${dMDateDropdown}` +
                `</div></div>` +
                `${onlyWorkdaysCheckbox}` +
                `<div class="period">` +
                `<div class="radio-buttons">${radioButtons}</div>` +
                `<div class="dates-container">` +
                `<div class="dates month-year">${mYFromDateDropdown}<p>–</p>${mYToDateDropdown}</div>` +
                `<div class="dates year">${yearFromDateDropdown}<p>–</p>${yearToDateDropdown}</div>` +
                `</div></div><button class="close">Готово</button></div>`;

            //Outside the window
            const errors1 = `<div class="payment-err error-text">укажите сумму</div>`;
            const errors2 = `<div class="empty-err error-text">тестовая ошибка</div>` +
                `<div class="purpose-err error-text">укажите тип погашения</div>` +
                `<div class="empty-date-err error-text">укажите дату${type === 'withdrawal' ? ' снятия' : ''}${type === "replenishment" ? ' пополнения' : ''}</div>` +
                `<div class="empty-day-err error-text">укажите дату повторения</div>` +
                `<div class="empty-period-err error-text">укажите период повторения</div>` +
                `<div class="empty-start-err error-text">укажите начало периода повторения</div>` +
                `<div class="empty-end-err error-text">укажите конец периода повторения</div>` +
                `<div class="from-bound-err error-text">расчёт возможен с 01.01.1995</div>` +
                `<div class="end-before-start-err error-text">${type == "repayment" ? `дата конца платежей не может быть раньше даты начала платежей` : ``}</div>` +
                `<div class="before-start-err error-text">${type == "repayment" ? `досрочное погашение не может быть раньше даты открытия кредита` : `дата ${type === 'withdrawal' ? 'частичного снятия' : ''}${type === "replenishment" ? 'пополнения вклада' : ''} не может быть раньше или равна дате открытия вклада`}</div>` +
                `<div class="after-end-err error-text">${type == "repayment" ? `досрочное погашение не может быть позже даты закрытия кредита` : `дата ${type === 'withdrawal' ? 'частичного снятия' : ''}${type === "replenishment" ? 'пополнения вклада' : ''} не может быть позже даты закрытия вклада`}</div>` +
                `<div class="interval-err error-text">дата конца периода не может быть раньше даты начала периода</div>` +
                `<div class="day-year-err error-text">выбран невалидный день месяца для повтора</div>`;

            const plateText = allowedTypes.find(t => t == type) ?
                `<div><span class="name hidden-control"></span></div>` +
                `<div class="money-div"><span class="money"></span>` +
                `<div class="error-text-block-1">${errors1}</div></div>` +
                `<div><span class="fresh"></span></div>` +
                (type == "repayment" ? `<div class="purpose hidden-control"><span></span></div>` : ``) +
                `<div class="repeat hidden-control"><span></span></div>` +
                `<div class="only-workdays hidden-control"><span>` +
                `${type == "repayment" ? 'переносить дату платежей, если платёж приходится на нерабочий день' : ''}` +
                `${type == "withdrawal" ? 'переносить снятие, если оно приходится на нерабочий день' : ''}` +
                `${type == "replenishment" ? 'переносить пополнение, если оно приходится на нерабочий день' : ''}` +
                `</span></div>` +
                `<div class="error-text-block-2">${errors2}</div>`
                : `Error: unsupported type`;
            const plateDiv = `<div class="plate"><div class="plate-text">${plateText}</div>${pencilicon}</div>`;

            //scss
            const stylesHtml = `<link rel="stylesheet" href="${mainStyles}?v=${cssSalt}" /><link rel="stylesheet" href="${styles}?v=${cssSalt}" />`;

            //Add html to the element
            this.attachShadow({ mode: 'open' });
            this.shadowRoot.innerHTML = stylesHtml + `<div class="summary ${type}-type-div">${plateDiv}${windowDiv}</div>`;
        };

        //Open and close the window
        const inputBreaker = (e) => {
            e.stopPropagation();
        };

        this.closeWindow = () => {
            if (this.$elements.$windowDiv.hasClass('active')) {
                this.$elements.$windowDiv.removeClass('active');
                $(window).off("click", closeWindowOutside);
                this.$elements.$closeButton.off("click", this.closeWindow);
                this.$elements.$repetitionDropdown.off('change', afterChangeInRepeat);
                this.$elements.$nameInput.off('change', inputBreaker);
                this.$elements.$sumInput.off('change', inputBreaker);
                this.$elements.$datesMYFrom.off('change', switchRadio);
                this.$elements.$datesMYTo.off('change', switchRadio);
                this.$elements.$datesYearFrom.off('change', switchRadio);
                this.$elements.$datesYearTo.off('change', switchRadio);

                recieveValues();
                updateText();
                this.$elements.$summaryInput.trigger('change', this);
            }
        };

        const closeWindowOutside = (e) => {
            if (!this.$elements.$summaryInput.is(e.target) && !this.$elements.$summary.is(e.target) && this.$elements.$summary.has(e.target).length === 0) {
                this.closeWindow();
            }
        };

        const unfocus = (e) => {
            const active = this.$elements.$shadowRoot[0].activeElement;
            if (e.originalEvent && e.originalEvent.composedPath().indexOf(active) == -1)
                document.activeElement.blur();
        };

        const switchRadio = (e) => {
            this.$elements.$radioButtons.find(`input#${id}_dates`).prop("checked", true);
        };

        this.openWindow = () => {
            if (allowedTypes.find(t => t == type) && !this.$elements.$windowDiv.hasClass('active')) {
                this.$elements.$windowDiv.addClass('active');
                $(window).on("click", closeWindowOutside);
                this.$elements.$closeButton.on("click", this.closeWindow);
                this.$elements.$repetitionDropdown.on('change', afterChangeInRepeat);
                this.$elements.$nameInput.on('change', inputBreaker);
                this.$elements.$sumInput.on('change', inputBreaker);
                this.$elements.$windowDiv.on('click', unfocus);
                this.$elements.$datesMYFrom.on('change', switchRadio);
                this.$elements.$datesMYTo.on('change', switchRadio);
                this.$elements.$datesYearFrom.on('change', switchRadio);
                this.$elements.$datesYearTo.on('change', switchRadio);
            }
        };

        // Fix for the de-sync between closing this window and date-dropdown
        this.innerClosing = (e) => {
            e.stopPropagation();
            if (!this.$elements.$windowDiv.hasClass('active')) {
                recieveValues();
                updateText();
            }
        }

        //Collect elements through jquery
        const getElements = () => {
            const $summaryInput = $(this);
            const $shadowRoot = $($summaryInput[0].shadowRoot);
            const $summary = $shadowRoot.find(".summary");

            const $plate = $summary.find('.plate');
            const $plateText = $plate.find('.plate-text');
            const $windowDiv = $summary.find('.window-div');

            const $nameText = $plateText.find('.name');
            const $moneyText = $plateText.find('.money');
            const $freshText = $plateText.find('.fresh');
            const $purposeText = $plateText.find('.purpose');
            const $repeatDiv = $plateText.find('.repeat');
            const $repeatText = $repeatDiv.find('span');
            const $onlyWorkdaysDiv = $plateText.find('.only-workdays');

            const $closeButton = $windowDiv.find('button.close');
            const $sumInput = $windowDiv.find('.sum-field > input');
            const $nameInput = $windowDiv.find('.title > input');

            const $purposeDropdown = $windowDiv.find('div.purpose > dropdown-select');
            const $repetitionDropdown = $windowDiv.find('div.repetition > div.selectors > dropdown-select');
            const $dateDiv = $windowDiv.find('div.date');
            const $dMYDateDropdown = $dateDiv.find('date-dropdown.day-month-year');
            const $dayDateDropdown = $dateDiv.find('date-dropdown.day');
            const $dMDateDropdown = $dateDiv.find('date-dropdown.day-month');

            const $period = $windowDiv.find('.period');
            const $radioButtons = $period.find('.radio-buttons');
            const $datesContainer = $period.find('.dates-container');
            const $datesMY = $datesContainer.find('.dates.month-year');
            const $datesYear = $datesContainer.find('.dates.year');
            const $datesMYFrom = $datesMY.find('.date-from');
            const $datesMYTo = $datesMY.find('.date-to');
            const $datesYearFrom = $datesYear.find('.date-from');
            const $datesYearTo = $datesYear.find('.date-to');

            const $onlyWorkdaysCheckbox = $windowDiv.find('.only-workdays input');

            this.$elements = {
                $summaryInput, $shadowRoot, $summary,
                $plate, $plateText, $windowDiv,
                $nameText, $moneyText, $freshText,
                $purposeText, $repeatDiv, $repeatText, $onlyWorkdaysDiv,
                $closeButton, $sumInput, $nameInput,
                $purposeDropdown, $repetitionDropdown,
                $dateDiv, $dMYDateDropdown, $dayDateDropdown,
                $dMDateDropdown,
                $period, $radioButtons, $datesContainer, $datesMY, $datesYear,
                $datesMYFrom, $datesMYTo, $datesYearFrom, $datesYearTo,
                $onlyWorkdaysCheckbox
            };
        };

        //3. Setup

        //Set initial state for the element
        setDays();
        createHtml();
        getElements();

        //Set initial values
        this.setValues(this._defaultValue);

        //Tune sum input
        this.$elements.$sumInput.inputFilter(true, {});
    }

    get value() {
        return this._value;
    }

    set value(v) {
        this.setValues(v);
    }

    get defaultValue() {
        return this._defaultValue;
    }

    connectedCallback() {
        this.$elements.$plate.on("click", this.openWindow);
        this.$elements.$windowDiv.on("closure", this.innerClosing);
    }

    disconnectedCallback() {
        this.$elements.$plate.off("click", this.openWindow);
        this.$elements.$windowDiv.off("closure", this.innerClosing);
    }
}

class SummaryField extends _BaseObjectField {
    static keyName() { return 'summary'; }
    static getSummaryErrors($clone, parent, dateFromProp, dateToProp = '') {
        const $insideShadow = $($clone.find("summary-input")[0].shadowRoot);
        const basicCheck = (v) => {
            return !v || v.defaultInputs;
        }
        const checkDate = (d) => {
            return !!d && !!d.date;
        };
        const summaryDatePointsCheck = (v, checker) => {
            const checkFromTo = v.wholePeriod || checker(v.dateFrom) && checker(v.dateTo);
            switch (v.repeat) {
                case 'day':
                    return checkFromTo;
                case 'year':
                    return v.day && v.month && checkFromTo;
                case 'month': {
                    return v.day && checkFromTo;
                }
                case 'no': {
                    return checker(v.date);
                }
                default: {
                    return false;
                }
            }
        }

        const result = [
            {
                check: function (v) {
                    return !!v;
                },
                selector: $insideShadow.find('.empty-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.payment;
                },
                selector: $insideShadow.find('.payment-err')
            },
            {
                check: function (v) {
                    return !v || v.type !== "repayment" || v.defaultInputs || !!v.purpose;
                },
                selector: $insideShadow.find('.purpose-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.repeat != 'no' || checkDate(v.date);
                },
                selector: $insideShadow.find('.empty-date-err')
            },
            {
                check: function (v) {
                    switch (v.repeat) {
                        case 'year':
                            return basicCheck(v) || v.day && v.month;
                        case 'month': {
                            return basicCheck(v) || v.day;
                        }
                    }
                    return true;
                },
                selector: $insideShadow.find('.empty-day-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.repeat == 'no' || v.wholePeriod || checkDate(v.dateFrom) || checkDate(v.dateTo);
                },
                selector: $insideShadow.find('.empty-period-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.repeat == 'no' || v.wholePeriod || checkDate(v.dateFrom);
                },
                selector: $insideShadow.find('.empty-start-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.repeat == 'no' || v.wholePeriod || checkDate(v.dateTo);
                },
                selector: $insideShadow.find('.empty-end-err')
            },
            {
                check: function (v) {
                    const checker = (d) => {
                        return !d || !d.date || !d.goesBefore(new DatePoint("01.01.1995"));
                    };
                    return basicCheck(v) || summaryDatePointsCheck(v, checker);
                },
                selector: $insideShadow.find('.from-bound-err')
            },
            {
                check: function (v) {
                    const checker = (d) => {
                        const mainDate = parent[dateFromProp];
                        if (!d || !d.date || !mainDate || v.type != "repayment" || v.repeat == 'no' || v.wholePeriod)
                            return true;
                        switch (v.repeat) {
                            case 'year':
                            case 'month': {
                                let fixedD, lastD;
                                if (v.repeat == 'year') {
                                    fixedD = new DatePoint(new Date(d.date.getFullYear(), (v.month || 1) - 1, v.day || 1));// instead of fixDayMonthYear
                                    lastD = new DatePoint(new Date(d.date.getFullYear(), (v.month || 1) - 1, 1));// instead of fixDayMonthYear
                                } else {
                                    fixedD = new DatePoint(new Date(d.date.getFullYear(), d.date.getMonth(), v.day || 1));// instead of fixDayMonthYear
                                    lastD = new DatePoint(new Date(d.date.getFullYear(), d.date.getMonth(), 1));// instead of fixDayMonthYear
                                }
                                lastD.addMonths(1);
                                lastD.inc(-1);
                                const realD = v.day != -1 && fixedD.distanceTo(lastD) > 0 ? fixedD : lastD;
                                return realD.distanceTo(mainDate) < (2);
                            }
                            default: {
                                return false;
                            }
                        }
                    };
                    return basicCheck(v) || checker(v.dateTo);
                },
                selector: $insideShadow.find('.end-before-start-err')
            },
            {
                check: function (v) {
                    const checker = (d) => {
                        const mainDate = parent[dateFromProp];
                        if (!d || !d.date || !mainDate)
                            return true;
                        switch (v.repeat) {
                            case 'year':
                            case 'month': {
                                let fixedD, lastD;
                                if (v.repeat == 'year') {
                                    fixedD = new DatePoint(new Date(d.date.getFullYear(), (v.month || 1) - 1, v.day || 1));// instead of fixDayMonthYear
                                    lastD = new DatePoint(new Date(d.date.getFullYear(), (v.month || 1) - 1, 1));// instead of fixDayMonthYear
                                } else {
                                    fixedD = new DatePoint(new Date(d.date.getFullYear(), d.date.getMonth(), v.day || 1));// instead of fixDayMonthYear
                                    lastD = new DatePoint(new Date(d.date.getFullYear(), d.date.getMonth(), 1));// instead of fixDayMonthYear
                                }
                                lastD.addMonths(1);
                                lastD.inc(-1);
                                const realD = v.day != -1 && fixedD.distanceTo(lastD) > 0 ? fixedD : lastD;
                                return realD.distanceTo(mainDate) < (v.type == "repayment" ? 2 : 1);
                            }
                            case 'no': {
                                return d.distanceTo(mainDate) < (v.type == "repayment" ? 2 : 1);
                            }
                            default: {
                                return false;
                            }
                        }
                    };
                    return basicCheck(v) || summaryDatePointsCheck(v, checker);
                },
                selector: $insideShadow.find('.before-start-err')
            },
            {
                check: function (v) {
                    const checker = (d) => {
                        const mainDate = parent[dateToProp];
                        if (!d || !d.date || !mainDate)
                            return true;
                        switch (v.repeat) {
                            case 'year':
                            case 'month': {
                                let fixedD, lastD;
                                if (v.repeat == 'year') {
                                    fixedD = new DatePoint(new Date(d.date.getFullYear(), (v.month || 1) - 1, v.day || 1));// instead of fixDayMonthYear
                                    lastD = new DatePoint(new Date(d.date.getFullYear(), (v.month || 1) - 1, 1));// instead of fixDayMonthYear
                                } else {
                                    fixedD = new DatePoint(new Date(d.date.getFullYear(), d.date.getMonth(), v.day || 1));// instead of fixDayMonthYear
                                    lastD = new DatePoint(new Date(d.date.getFullYear(), d.date.getMonth(), 1));// instead of fixDayMonthYear
                                }
                                lastD.addMonths(1);
                                lastD.inc(-1);
                                let realD = v.day != -1 && fixedD.distanceTo(lastD) > 0 ? fixedD : lastD;
                                if (v.onlyWorkdays && v.type != "repayment") {
                                    while (realD.isDayOff()) {
                                        realD.inc();
                                    }
                                }
                                return realD.distanceTo(mainDate) > 0;
                            }
                            case 'no': {
                                let realD = d.copy();
                                if (v.onlyWorkdays && v.type != "repayment") {
                                    while (realD.isDayOff()) {
                                        realD.inc();
                                    }
                                }
                                return realD.distanceTo(mainDate) > 0;
                            }
                            default: {
                                return false;
                            }
                        }
                    };
                    return basicCheck(v) || summaryDatePointsCheck(v, checker);
                },
                selector: $insideShadow.find('.after-end-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.repeat == 'no' || v.wholePeriod || !v.dateTo || !v.dateTo.date || !v.dateFrom || !v.dateFrom.date || !v.dateTo.goesBefore(v.dateFrom);
                },
                selector: $insideShadow.find('.interval-err')
            },
            {
                check: function (v) {
                    return basicCheck(v) || v.repeat != 'year' || v.day < 30 || (v.month != 2 && (v.day == 30 || ![4, 6, 9, 11].includes(v.month)));
                },
                selector: $insideShadow.find('.day-year-err')
            },
        ];

        return result;
    }
}

window.customElements.define('summary-input', SummaryInput);

export { SummaryField };
